import {Vue} from "vue-property-decorator";
import {ENV} from "@/apps/rever-academy/components/Constant";

export default class Mixin extends Vue{
  get baseUrl() {
    return ENV.BASE_URL
  }
  get hotline() {
    return ENV.VUE_APP_HOTLINE
  }
  get academyEmail() {
    return ENV.VUE_APP_ACADEMY_EMAIL
  }
  get hotlineOffice() {
    return ENV.VUE_APP_OFFICE
  }
  get feedbackHotline() {
    return ENV.VUE_APP_FEEDBACK_HOTLINE
  }
  get saleEmail() {
    return ENV.VUE_APP_SALES_EMAIL
  }
  get productEmail() {
    return ENV.VUE_APP_PROJECT_EMAIL
  }
  get address() {
    return ENV.VUE_APP_ADDRESS
  }
  get supportEmail() {
    return ENV.VUE_APP_SUPPORT
  }
  get reverWebUrl() {
    return ENV.VUE_APP_REVER_VN_ROOT_URL
  }
  get reverMst() {
    return ENV.VUE_APP_REVER_MST
  }
  get reverTechCompanyName() {
    return ENV.VUE_APP_REVER_TECH_COMPANY_NAME
  }

}
